import { render } from "./CardSetAssemblyView.vue?vue&type=template&id=08115ab9&scoped=true&ts=true"
import script from "./CardSetAssemblyView.vue?vue&type=script&lang=ts"
export * from "./CardSetAssemblyView.vue?vue&type=script&lang=ts"

import "./CardSetAssemblyView.vue?vue&type=style&index=0&id=08115ab9&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08115ab9"]])

export default __exports__